<template>
  <div class="word-preview-container">
    <div class="word-preview-content" v-html="convertedHtml"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import mammoth from 'mammoth';

const convertedHtml = ref('');

// 通过文件 URL 加载并转换 .docx
const loadDocx = async (url) => {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  const result = await mammoth.convertToHtml({ arrayBuffer });
  convertedHtml.value = result.value;
};

// 在生命周期钩子中调用
onMounted(async () => {
  let documentTitle = '田地科技隐私政策'; 
  const host = window.location.hostname;
  let docFile = '/yszc.docx';
  let flag = false;
  if(host === 'yhxy.tiandiyouxi.com'){
    docFile = '/yhxy.docx'
    documentTitle = '田地科技用户协议';
    flag = true;
  }
  document.title = documentTitle;
  await loadDocx(docFile);
  nextTick(() => {
    const container = document.querySelector('.word-preview-content');
    if (container && flag) {
      const firstChild = container.firstChild;
      if (firstChild) {
        if (firstChild.nodeType === 3) {
          // 如果第一行是文本节点，将其包裹在一个 <p> 标签中
          const p = document.createElement('p');
          p.textContent = firstChild.textContent;
          container.insertBefore(p, firstChild);
          container.removeChild(firstChild);
          p.style.textAlign = 'center';
          p.style.fontSize = '24px'; // 设置字体大小为小三对应的约 15px
        } else {
          firstChild.style.textAlign = 'center';
          firstChild.style.fontSize = '24px'; // 设置字体大小为小三对应的约 15px
        }
      }
    }
    // 手动为每个段落添加首行缩进样式，排除前两行
      const paragraphs = container.querySelectorAll('p');
      for (let i = 2; i < paragraphs.length; i++) {
        paragraphs[i].style.textIndent = '2em';
      }
  });
});
</script>

<style scoped>
.word-preview-container {
  display: flex;
  justify-content: center;
  align-items: flex-start; /* 垂直方向顶部对齐 */
  min-height: 100vh; /* 确保容器至少占满视口高度 */
  padding: 20px; /* 给容器添加一些内边距 */
  background-color: #f4f4f4; /* 设置背景颜色 */
}

.word-preview-content {
  width: 80%; /* 设置内容宽度 */
  max-width: 800px; /* 限制最大宽度 */
  padding: 40px; /* 给内容添加内边距 */
  background-color: #fff; /* 设置内容背景颜色 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

.word-preview-content img {
  max-width: 100%; /* 处理转换后的图片自适应 */
}

/* 设置每个段落首行缩进 2 个空格 */
.word-preview-content p {
  text-indent: 2em;
}
</style>